import { z } from "zod/v4";
export const noteAudienceSchema = z.enum(["gm", "player"]);
export const createMapNoteEntryInputSchema = z.object({
    title: z.string().optional().default(""),
    content: z.unknown().optional().default([]),
    audience: noteAudienceSchema.optional().default("gm"),
});
export const updateMapNoteEntryInputSchema = z.object({
    title: z.string().optional(),
    content: z.unknown().optional(),
});
